
<div class="d-flex flex-column justify-content-center position-relative w-100 h-100">
  <div class="disabled-overlay"></div>
  <!-- bloc pour l'image de background -->
  <MediaImageFocalPoint
    :content="{
      formatRatio: ratioImage,
      image: content.image,
      altImage: content.altImage,
      isBackground: true,
      lien: { field: 'lienInterne' },
      preload: preloadForAnimation,
    }"
    :show="show"
    :style="{ 'background-color': content.couleur }"
    class="image-fond h-100"
    @lazyImgLoaded.once="onLazyImgLoaded"
  >
  </MediaImageFocalPoint>
  <div
    ref="imgsupp"
    :class="{ 'ready-for-animation': imgLoaded }"
    class="images-supplementaires position-absolute"
  >
    <div class="degrade"></div>
    <!-- bloc pour l'image de personnage -->
    <MediaImageFocalPoint
      v-if="content.image3 !== undefined && content.image.metadata && content.image3.metadata"
      class="position-absolute additionnelle"
      :class="content.positionnementImage3"
      :content="{
        formatRatio: '4x3',
        image: content.image3,
        lien: { field: 'lienInterne' },
        preload: preloadForAnimation,
      }"
      :show="show"
      @lazyImgLoaded.once="onLazyImgLoaded"
    >
    </MediaImageFocalPoint>
    <!-- bloc pour le logo -->
    <MediaImageFocalPoint
      v-if="content.image2 !== undefined && content.image.metadata && content.image2.metadata"
      class="position-absolute centre h-100 w-100 justify-content-center logo"
      :content="{
        formatRatio: '16x9',
        image: content.image2,
        lien: { field: 'lienInterne' },
        isLogo: true,
        preload: preloadForAnimation,
      }"
      :show="show"
      @lazyImgLoaded.once="onLazyImgLoaded"
    >
    </MediaImageFocalPoint>
  </div>
</div>
